@switch (mode) {
  @case (TransferMode.Copy) {
    <ix-icon name="add_to_photos"></ix-icon>
    <div
      class="description"
      [innerHtml]="helptext.transfer_mode_warning_copy"
    ></div>
  }
  @case (TransferMode.Move) {
    <ix-icon name="move_to_inbox"></ix-icon>
    <div
      class="description"
      [innerHtml]="helptext.transfer_mode_warning_move"
    ></div>
  }
  @case (TransferMode.Sync) {
    <ix-icon name="sync"></ix-icon>
    <div
      class="description"
      [innerHtml]="helptext.transfer_mode_warning_sync"
    ></div>
  }
}
